import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { mdiChevronDown } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { MiAvatar } from "../MiAvatar/MiAvatar";
import { MiIcon } from "../MiIcon/MiIcon";

export const MiAvatarCard = memo(
  ({ isDropDown, text, subtext, src, onClick, small = false, testId }) => {
    const { classes, theme } = useStyles({ isDropDown, small });

    return (
      <Box
        className={classes.root}
        onClick={onClick}
        data-testId={testId ?? `mi-avatar-card`}
      >
        <MiAvatar className={classes.avatar} src={src} />
        {(text || subtext) && (
          <Box display="flex" flexDirection="column" alignContent="center">
            {text && (
              <Typography noWrap variant="body" className={classes.text}>
                {text}
              </Typography>
            )}
            {subtext && (
              <Typography noWrap className={classes.subtext}>
                {subtext}
              </Typography>
            )}
          </Box>
        )}
        {isDropDown && (
          <MiIcon
            path={mdiChevronDown}
            size={small ? 0.7 : 0.8}
            color={theme.palette.grey.medium}
            style={{ marginLeft: "auto" }}
          />
        )}
      </Box>
    );
  }
);

const useStyles = makeStyles()((theme, { isDropDown, small }) => ({
  root: {
    padding: theme.spacing(1, 1.5, 1, 2),
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.grey.lightAccent,
    width: "122px",
    height: small ? "24px" : "35px",
    transition: "background-color 0.3s ease",
    ...(isDropDown && {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: theme.palette.grey.accent,
      },
    }),
  },
  avatar: {
    width: small ? 16 : 24,
    height: small ? 16 : 24,
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.grey.darkAccent,
    fontSize: theme.fontSize.small,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    color: theme.palette.grey.medium,
  },
  text: {
    fontSize: theme.typography.pxToRem(small ? 14 : 11),
    fontWeight: small ? theme.fontWeight.bold : theme.fontWeight.regular,
    color: small ? theme.palette.common.black : theme.palette.grey.medium,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "90px",
    margin: 0,
  },
  subtext: {
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.fontWeight.bold,
    color: theme.palette.bluegrey.dark,
    textOverflow: "ellipsis",
    maxWidth: "70px",
  },
}));
